// Local state machine for the multi-date round adder. selectedDays is a
// multiset: a day picked N times appears N times and creates N rounds on that
// date, mirroring the Calendar > Add Rounds multiDatesPicker behavior.
// Kept free of React/moment so it can be unit tested in isolation.

export const MAX_ROUNDS = 10

export const INITIAL_STATE = {
  selectedDays: [],
  dayDialog: null,
}

const ACTION_TYPES = {
  DAY_CLICKED: 'DAY_CLICKED',
  ADD_ANOTHER_ROUND: 'ADD_ANOTHER_ROUND',
  REMOVE_ROUND: 'REMOVE_ROUND',
  CLOSE_DAY_DIALOG: 'CLOSE_DAY_DIALOG',
  RESET: 'RESET',
}

// Action creators — components dispatch these instead of building action objects
export const dayClicked = (day) => ({ type: ACTION_TYPES.DAY_CLICKED, day })
export const addAnotherRound = () => ({ type: ACTION_TYPES.ADD_ANOTHER_ROUND })
export const removeRound = () => ({ type: ACTION_TYPES.REMOVE_ROUND })
export const closeDayDialog = () => ({ type: ACTION_TYPES.CLOSE_DAY_DIALOG })
export const reset = () => ({ type: ACTION_TYPES.RESET })

export const isSameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()

// Selectors

export const roundsOnDay = (selectedDays, day) =>
  selectedDays.filter(selected => isSameDay(selected, day)).length

export const canAddRound = (selectedDays) => selectedDays.length < MAX_ROUNDS

export const sortedDays = (selectedDays) => [ ...selectedDays ].sort((a, b) => a - b)

// Reducer

const addDay = (state, day) => (
  canAddRound(state.selectedDays) ? { ...state, selectedDays: [ ...state.selectedDays, day ] } : state
)

const removeOneRound = (state, day) => {
  const removeIndex = state.selectedDays.findIndex(selected => isSameDay(selected, day))
  if (removeIndex === -1) { return state }

  return { ...state, selectedDays: state.selectedDays.filter((_, index) => index !== removeIndex) }
}

export const roundDaysReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.DAY_CLICKED:
      // A day that already has rounds opens the per-day dialog instead of stacking another one
      if (roundsOnDay(state.selectedDays, action.day) > 0) { return { ...state, dayDialog: action.day } }

      return addDay(state, action.day)

    case ACTION_TYPES.ADD_ANOTHER_ROUND:
      if (!state.dayDialog) { return state }

      return { ...addDay(state, state.dayDialog), dayDialog: null }

    case ACTION_TYPES.REMOVE_ROUND:
      if (!state.dayDialog) { return state }

      return { ...removeOneRound(state, state.dayDialog), dayDialog: null }

    case ACTION_TYPES.CLOSE_DAY_DIALOG:
      return { ...state, dayDialog: null }

    case ACTION_TYPES.RESET:
      return INITIAL_STATE

    default:
      return state
  }
}
